var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "lineBox" },
    [
      _c("el-card", [
        _c("div", { ref: "lineTitle" }, [
          _vm._v(" " + _vm._s(_vm.$t("PaymentTrends.PaymentTrends")) + " "),
        ]),
      ]),
      _c("el-card", [
        _c("div", { ref: "echart", staticStyle: { width: "100%" } }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }